import useLandLink from "@/modules/pe-basic-module/hooks/useLandLink"
import { Button, Intent } from "@blueprintjs/core"
import { Link } from "react-router-dom"
import { ILand } from "../../data/interfaces"
import useLand from "@/modules/pe-basic-module/hooks/useLand"

/* Protopia Ecosystem component */
export interface IBackLinkProps {
   intent?: Intent
}
const BackLink = (props: IBackLinkProps): JSX.Element => {
    const land: ILand = useLand()
    const landLink: string = useLandLink()
    return <Link to={landLink}>
        <Button intent={ props.intent || Intent.DANGER } icon="arrow-left" >
            {land.title}
        </Button>
    </Link>
}
export default BackLink